/**
 * @desc fulfilmentList
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: Array<defs.fulfilment.StockAdjustmentFulfilmentMasterRequestDto>,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stockAdjustment/fulfilmentList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
